/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".pill-border[_ngcontent-%COMP%]{border-radius:20px;border:1px solid #ccc;padding:5px}  .input-dropdown-pill{padding-left:10px!important}  .input-pill{width:80%;border-radius:25px}.form-unit[_ngcontent-%COMP%]{margin-bottom:15px}.buttonsubmit[_ngcontent-%COMP%]{width:225px!important;border-radius:25px!important}  .input-dropdown-pill .ui-dropdown-trigger-icon{left:10%!important}[_ngcontent-%COMP%]::-moz-placeholder{color:#000!important;padding-left:10px!important}[_ngcontent-%COMP%]::placeholder{color:#000!important;padding-left:10px!important}"];
export { styles as styles };

